import React from "react";
import TransportRouteDesigner from "./transport-route-designer";

// Standalone layout for Route Designer without sidebar
const RouteDesignerPage = () => {
  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <TransportRouteDesigner />
    </div>
  );
};

export default RouteDesignerPage;
